import styled from "styled-components";

export const CarouselSliderStyle = styled.div`
  position: relative;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  width: 1589px;
  height: 872px;
  border-radius: 8px;
  overflow: hidden;
  touch-action: none;

  img {
    /* Contain within the slide box: tall images used to grow past the
       872px box (width:100% + auto height) and get cropped away. */
    object-fit: contain !important;
    user-select: none;
    width: 100%;
    max-height: 100%;
  }
`;

export const CarouselLegenda = styled.div`
  pointer-events: none;
  position: absolute;
  z-index: 10;
  right: 24px;
  bottom: 20px;
  max-width: 45%;

  font-family: var(--app-font-family, "DM Sans", sans-serif);
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 1.3;
  text-align: right;
  color: #ffffff;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.85);
`;
